import { useNavigate } from 'react-router-dom';
import { routes } from '@lib/routes';

export default function Header() {
  const navigate = useNavigate();

  return (
    <div className="h-12 bg-veritas-navy flex items-center justify-between px-4 sm:px-6 lg:px-8">
      <button
        onClick={() => navigate(routes.landing)}
        className="flex items-center gap-2 text-white text-sm font-sans font-semibold hover:opacity-80 transition-opacity"
      >
        <img src="/brand/veritas-icon-white.svg" alt="" className="h-8 w-8" aria-hidden="true" />
        <span>← Veritas</span>
      </button>
      <div className="flex items-center gap-6">
        <a href={`${routes.landing}#how-it-works`} className="text-white text-xs uppercase tracking-wider hover:opacity-80 transition-opacity">How It Works</a>
        <a href={`${routes.landing}#pricing`} className="text-white text-xs uppercase tracking-wider hover:opacity-80 transition-opacity">Pricing</a>
        <button
          onClick={() => navigate(routes.contact)}
          className="text-white text-xs uppercase tracking-wider hover:opacity-80 transition-opacity"
        >
          Contact
        </button>
      </div>
    </div>
  );
}
